import {
  FormControl,
  MenuItem,
  Select,
  TableCell,
  Typography,
} from '@mui/material';
import useAppStore from '../../store/useAppStore';
import { memo, useMemo } from 'react';

const StationSelect = ({ index, placeholder, valueKey }) => {
  const station = useAppStore((state) => state.scripts[index][valueKey]);
  const stations = useAppStore((state) => state.stations);
  const setter = useAppStore((state) => state.setter);
  const readOnly = useAppStore((state) => state.selectedProject.readOnly);
  const selectedDevice = useMemo(() => {
    if (station.id === 'NotFound') {
      return station.content;
    }
    if (!station.id) {
      return '';
    }
    console.log('station.id =', station.id)
    console.log('stations =', stations)
    //return stations.find(({ id }) => id === station.id)['項目'];
    return stations.find(({ id }) => id === station.id)?.['項目'];
  }, [station, stations]);
  if (readOnly) {
    return (
      <TableCell sx={{ p: 1 }}>
        <Typography>{selectedDevice}</Typography>
      </TableCell>
    );
  }
  return (
    <TableCell sx={{ p: 1 }}>
      <FormControl fullWidth size="small">
        <Select
          value={station.id || ''}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const station = stations.find(
              (station) => station.id === selectedValue,
            );
            setter('scripts', (draft) => {
              draft[index][valueKey] = {
                id: selectedValue,
                content: station['項目'],
              };
            });
          }}
          displayEmpty
          renderValue={
            station.id
              ? undefined
              : () => {
                return <span style={{ color: '#999' }}>{placeholder}</span>;
              }
          }
        >
          {station.id === 'NotFound' && (
            <MenuItem key={station.id} value={station.id}>
              {station.content}
            </MenuItem>
          )}
          {stations.map((station) => (
            <MenuItem key={station.id} value={station.id}>
              {station['項目']} - {station['類別']}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </TableCell>
  );
};
export default memo(StationSelect);
